<template>
  <div class="mb-2" >
    <h4 v-if="!isRegistering" class="mb-3">{{ $t(LangConstants.company_details_step_label) }}</h4>
    <div class="container justify-content-center form-base">
      <b-form ref="frmBasicData" @submit.stop.prevent="proceedBtnHandler">
        <div class="col-12 form1">
          <div class="row">
            <div class="col-md-6 mb-4">
              <my-input id="company-name" name="company-name" type="text" mandatory="true" v-model="company.name" :label="$t(LangConstants.company_name_input_label)" :placeholder="LangConstants.company_name_placeholder_label" inlinerows="false" classes="bg-gray" ref="companyName"></my-input>
            </div>
            <div class="col-md-6 mb-4">
              <my-input id="organization-number" name="organization-number" type="text" mandatory="true" v-model="company.organization_number" :label="$t(LangConstants.organization_number_label)" :placeholder="'0221212112'" inlinerows="false" classes="bg-gray" ref="orgNumber"></my-input>
            </div>
            <div class="col-md-6 mb-4">
              <my-input id="phone" name="phone" type="text" v-model="company.phone" :label="$t(LangConstants.phone_input_label)" :placeholder="'+13443543534534'" inlinerows="false" classes="bg-gray" ref="phone"></my-input>
            </div>
            <div class="col-md-6 mb-4">
              <my-input id="address" name="address" type="text" v-model="company.address" :label="$t(LangConstants.address_input_label)" :placeholder="'1st lane'" inlinerows="false" classes="bg-gray" ref="address"></my-input>
            </div>
            <div class="col-md-6 mb-4">
              <my-input id="postal-code" name="postal-code" type="text" v-model="company.postal_code" :label="$t(LangConstants.postal_code_input_label)" :placeholder="'10005'" inlinerows="false" classes="bg-gray" ref="postalCode"></my-input>
            </div>
            <div class="col-md-6 mb-4">
              <my-input id="city" name="city" type="text" v-model="company.city" :label="$t(LangConstants.city_input_label)" :placeholder="'Stockholm'" inlinerows="false" classes="bg-gray" ref="city"></my-input>
            </div>
            <div class="col-md-6 mb-4">
              <my-input id="country" name="country" type="text" v-model="company.country" :label="$t(LangConstants.country_input_label)" :placeholder="'Sweden'" inlinerows="false" classes="bg-gray" ref="country"></my-input>
            </div>
            <div class="col-md-6 mb-4">
              <my-input id="invoice-reference" name="invoice-reference" type="text" v-model="company.invoice_reference" :label="$t(LangConstants.invoice_reference_input_label)" :placeholder="''" inlinerows="false" classes="bg-gray" ref="invoiceReference"></my-input>
            </div>
            <div class="col-md-6 mb-4">
              <my-input id="invoice-email" name="invoice-email" type="email" v-model="company.invoice_email" :label="$t(LangConstants.invoive_email_input_label)" :placeholder="'someemail@example.com'" inlinerows="false" classes="bg-gray" ref="invoiceEmail"></my-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 mb-4">
              <my-button :fa="!isRegistering ? 'save' : 'check'" :label="!isRegistering ? $t(LangConstants.save_changes_button_label) : $t(LangConstants.proceed_to_settings_form_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import Constants from "../../constants/index";
import MyInput from "../../components/atoms/Input.vue";
import MyButton from "../../components/atoms/Button.vue";

import "../../assets/scss/common.scss";

export default {
  name: "company-details",

  mounted() {
    this.$refs.companyName.text = this.company.name;
    this.$refs.orgNumber.text = this.company.organization_number;
    this.$refs.phone.text = this.company.phone;
    this.$refs.address.text = this.company.address;
    this.$refs.postalCode.text = this.company.postal_code;
    this.$refs.city.text = this.company.city;
    this.$refs.country.text = this.company.country;
    this.$refs.invoiceReference.text = this.company.invoice_reference;
    this.$refs.invoiceEmail.text = this.company.invoice_email;
  },

  data() {
    return {
      company: this.$props.companyForm,
    };
  },

  props: {
    companyForm: {
      required: true
    },
    isRegistering: {
      type: Boolean,
      default: false
    }
  },

  // watch: {
  //   companyForm: function (newCompanyForm) {
  //     console.log(1);
  //     console.log(newCompanyForm);
  //     this.$refs.companyName.text = newCompanyForm.name;
  //     this.$refs.orgNumber.text = newCompanyForm.organization_number;
  //     this.$refs.phone.text = newCompanyForm.phone;
  //     this.$refs.address.text = newCompanyForm.address;
  //     this.$refs.postalCode.text = newCompanyForm.postal_code;
  //     this.$refs.city.text = newCompanyForm.city;
  //     this.$refs.country.text = newCompanyForm.country;
  //     this.$refs.invoiceReference.text = newCompanyForm.invoice_reference;
  //     this.$refs.invoiceEmail.text = newCompanyForm.invoice_email;
  //   }
  // },

  computed: {
    LangConstants() {
      return Constants;
    },
  },

  methods: {
    proceedBtnHandler() {
      this.$emit("save", this.company);
    },
  },

  components: {
    MyInput,
    MyButton,
  },
};
</script>
